import { useEffect, useState } from "react";

import { Button, Card, CardBody, CardHeader, Table } from "reactstrap";

//Unform e componentes
import TooltipItem from "@/frontend/componentes/TooltipItem.jsx";
import { MessageConfirm } from "@/frontend/componentes/Message.jsx";
import ModalInfoJson from "@/frontend/componentes/ModalInfoJson.jsx";
import ModalTexto from "@/frontend/componentes/ModalTexto.jsx";

//Util
import { ICONES, ICONES_MENSAGEM } from "@/frontend/utils/icones.jsx";

//API
import {
  api_finalizarConexaoID,
  api_finalizarConexoesBDInativas,
  api_listarConexoesBD,
} from "@/frontend/services/api/api_system.jsx";
import TEncerrar_conexao_bd from "./encerrar_conexao_bd";

//Telas
// import TEncerrar_conexao_bd from "./encerrar_conexao_bd.jsx";
// import TUltimos_logs_erro from "./log/ultimos_logs_erro.jsx";

function TDashboard_system() {
  //### USE STATE ###
  const [modalOpenInfoBD, setModalOpenInfoBD] = useState(false);
  const [modalOpenLogs, setModalOpenLogs] = useState(false);
  const [modalOpenTexto, setModalOpenTexto] = useState(false);
  const [modalOpenEncerrar, setModalOpenEncerrar] = useState(false);

  const [conexoesBD, setConexoesBD] = useState([]);
  const [infoBD, setInfoBD] = useState([]);

  const [conexaoEncerrar, setConexaoEncerrar] = useState(null);
  const [colunaTextoModal, setcolunaTextoModal] = useState(null);
  const [textoModal, setTextoModal] = useState(null);

  const [keyAtualizarPage, setKeyAtualizarPage] = useState(0);

  //### USE EFFECT ###
  //Inicialização da tela
  useEffect(() => {
    async function listarConexoesBD() {
      const result = await api_listarConexoesBD();

      if (result) {
        setInfoBD(result.info);
        setConexoesBD(result.rows);
      }
    }

    listarConexoesBD();
  }, [keyAtualizarPage]);

  //### FUNCOES ###

  //### EVENTOS ###
  //OnClick - Encerrar conexões inativas
  async function handleBotaoEncerrarInativos() {
    const result = await MessageConfirm(
      "Conexões inativas",
      "Confirma o encerramento das conexões inativas?",
    );

    if (result == 1) {
      await api_finalizarConexoesBDInativas();
      setKeyAtualizarPage((prev) => prev + 1);
    }
  }

  //OnClick - Botão informações conexao BD
  function handleBotaoInfoBD() {
    setModalOpenInfoBD(true);
  }

  // //OnClick - Botão Últimos logs erro
  // async function handleBotaoLogsErro() {
  //   setModalOpenLogs(true);
  // }

  //OnClick - Botão visualizar texto completo
  function abrirValorCompleto(nomeColuna, texto) {
    setcolunaTextoModal(nomeColuna);
    setTextoModal(texto);
    setModalOpenTexto(true);
  }

  //OnClick - Botão Encerrar conexão específica
  async function handleBotaoEncerrarConexao(row) {
    //Se for conexão inativa deixa encerrar sem pedir autorização
    if (row?.state == "idle") {
      const id = row?.pid || row?.sid;
      const serial = row?.serial;

      const result = await MessageConfirm(
        "Encerrar conexão",
        `Confirma o encerramento da conexão inativa <strong>${id}</strong>?`,
      );

      if (result == 1) {
        await api_finalizarConexaoID(id, serial);
        setKeyAtualizarPage((prev) => prev + 1);
      }
    } else {
      setConexaoEncerrar(row);
      setModalOpenEncerrar(true);
    }
  }

  return (
    <div className="m-3">
      <br />

      <div className="d-flex align-items-center">
        <div className="me-2">
          <Button
            name="btnInfoBD"
            size="sm"
            className="btn-info"
            onClick={handleBotaoInfoBD}
          >
            {ICONES_MENSAGEM.INFO} Informações conexão
          </Button>
        </div>

        {/* <div className="me-2">
          <Button
            name="btnLogErro"
            size="sm"
            className="btn-atencao"
            onClick={handleBotaoLogsErro}
          >
            {ICONES_MENSAGEM.ERRO} Últimos logs erro
          </Button>
        </div> */}
      </div>

      <br />

      <div>
        {conexoesBD.length > 0 && (
          <Card>
            <CardHeader>
              <div className="d-flex align-items-center justify-content-center fw-bold">
                Conexões banco de dados
              </div>
            </CardHeader>

            <CardBody>
              <Table responsive>
                <thead>
                  <tr>
                    {Object.keys(conexoesBD[0]).map((col, idx) => (
                      <td key={idx} className="table-header">
                        {col}
                      </td>
                    ))}

                    <td width="5%" align="center" className="table-header">
                      Encerrar
                    </td>
                  </tr>
                </thead>

                <tbody>
                  {conexoesBD.map((row, rowIndex) => {
                    const colunas = Object.keys(row);

                    return (
                      <tr key={rowIndex}>
                        {Object.values(row).map((val, colIndex) => {
                          const strVal = String(val);
                          const isLong = strVal.length > 80;
                          const nomeColuna = colunas[colIndex];

                          return (
                            <td key={colIndex}>
                              {isLong ? (
                                <>
                                  <div className="d-flex">
                                    <div
                                      onClick={() =>
                                        abrirValorCompleto(nomeColuna, strVal)
                                      }
                                      className="ms-2 me-2 cursor-pointer"
                                      style={{
                                        color: "#007bff",
                                      }}
                                    >
                                      <TooltipItem text="Visualizar valor completo">
                                        {ICONES.DETALHE}
                                      </TooltipItem>
                                    </div>
                                    {strVal.slice(0, 80)}...
                                  </div>
                                </>
                              ) : (
                                strVal
                              )}
                            </td>
                          );
                        })}
                        <td align="center">
                          <Button
                            name={`btnEncerrar${rowIndex}`}
                            size="sm"
                            color={
                              row?.state == "idle" ? "secondary" : "danger"
                            }
                            onClick={() => handleBotaoEncerrarConexao(row)}
                          >
                            {ICONES.PARAR}
                          </Button>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </Table>
            </CardBody>
          </Card>
        )}

        <br />

        <div className="d-flex align-items-center justify-content-end">
          <Button
            name="btnEncerrarInativo"
            color="secondary"
            onClick={handleBotaoEncerrarInativos}
          >
            {ICONES.PARAR} Encerrar conexões inativas
          </Button>
        </div>

        <br />
        <br />
      </div>

      {/* MODAL INFO BD */}
      {modalOpenInfoBD && (
        <ModalInfoJson
          modalOpen={modalOpenInfoBD}
          toggleModal={() => setModalOpenInfoBD(!modalOpenInfoBD)}
          titulo={"Informações conexão"}
          infoJson={infoBD}
        />
      )}

      {/* MODAL LOGS */}
      {/* {modalOpenLogs && (
        <TUltimos_logs_erro
          modalOpen={modalOpenLogs}
          toggleModal={() => setModalOpenLogs(!modalOpenLogs)}
          limit={15}
        />
      )} */}

      {/* MODAL TEXTO */}
      {modalOpenTexto && (
        <ModalTexto
          modalOpen={modalOpenTexto}
          toggleModal={() => setModalOpenTexto(!modalOpenTexto)}
          titulo={colunaTextoModal}
          texto={textoModal}
        />
      )}

      {/* MODAL ENCERRAR CONEXAO */}
      {modalOpenEncerrar && (
        <TEncerrar_conexao_bd
          modalOpen={modalOpenEncerrar}
          toggleModal={() => setModalOpenEncerrar(!modalOpenEncerrar)}
          conexao={conexaoEncerrar}
          setKeyAtualizar={setKeyAtualizarPage}
        />
      )}
    </div>
  );
}

export default TDashboard_system;
